'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = '4';
var width = 384;
var height = 512;
var aliases = [];
var unicode = '34';
var svgPathData = 'M320 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 248-208 0c-8.8 0-16-7.2-16-16L48 56c0-13.3-10.7-24-24-24S0 42.7 0 56L0 288c0 35.3 28.7 64 64 64l208 0 0 104c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-248z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.fa4 = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;